<template>
  <div v-if="dados.nota == null" class="b44-np b44-np--vazio">
    <div class="b44-np__title">
      <i class="bi bi-speedometer2"></i>
      <h3>Saúde do Portfólio</h3>
      <HelpTip tip="dash_nota_portfolio" />
    </div>
    <p class="b44-np__vazio-texto">Nenhum projeto em andamento para apurar a nota.</p>
  </div>

  <div v-else class="b44-np" :class="faixa.key">
    <div class="b44-np__main">
      <div class="b44-np__circle" :style="{ backgroundColor: faixa.hex }">{{ dados.nota }}</div>
      <div>
        <div class="b44-np__title">
          <i class="bi bi-speedometer2"></i>
          <h3>Saúde do Portfólio</h3>
          <HelpTip tip="dash_nota_portfolio" />
        </div>
        <p class="b44-np__label">{{ dados.label || faixa.label }}</p>
        <p class="b44-np__desc">
          Média ponderada pelo impacto estratégico dos projetos em andamento (quanto maior, melhor)
        </p>
      </div>
    </div>

    <div class="b44-np__dist">
      <div v-for="item in distItems" :key="item.key" class="b44-np__dist-item">
        <div class="b44-np__dist-head">
          <span class="b44-np__dist-label">{{ item.label }}</span>
          <span class="b44-np__dist-count">{{ item.count }}</span>
        </div>
        <div class="b44-np__dist-bar">
          <span :class="item.key" :style="{ width: larguraBarra(item.count) }"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelpTip from "@/components/PortfolioAuditor/HelpTip.vue";
import {
  FAIXAS_SAUDE_PORTFOLIO,
  calcularSaudePortfolio,
  cfgSaudePortfolio,
  classificarSaudePortfolio,
} from "@/utils/portfolio-notas";

export default {
  name: "NotaPortfolioCard",
  components: { HelpTip },
  props: {
    payload: { type: Object, default: null },
    projetos: { type: Array, default: () => [] },
  },
  computed: {
    dados() {
      const p = this.payload;
      if (p && typeof p === "object" && ("nota" in p || p.projetos_considerados != null)) {
        return {
          nota: p.nota ?? null,
          label: p.label ?? cfgSaudePortfolio(classificarSaudePortfolio(p.nota))?.label,
          projetos_considerados: p.projetos_considerados ?? 0,
          distribuicao: p.distribuicao || { otimo: 0, bom: 0, atencao: 0, critico: 0 },
        };
      }
      return calcularSaudePortfolio(this.projetos);
    },
    faixa() {
      return cfgSaudePortfolio(classificarSaudePortfolio(this.dados.nota)) || { key: "critico", label: "Crítico", hex: "#dc2626" };
    },
    distItems() {
      const d = this.dados.distribuicao || {};
      return FAIXAS_SAUDE_PORTFOLIO.map((f) => ({ key: f.key, label: f.label, count: d[f.key] || 0 }));
    },
  },
  methods: {
    larguraBarra(count) {
      const total = this.dados.projetos_considerados || 0;
      if (!total) return "0%";
      return `${Math.max(0, Math.min(100, (count / total) * 100))}%`;
    },
  },
};
</script>
